export default __webpack_public_path__ + "static/media/icon-wifi.b160982a.svg";